import { z } from 'zod';
import { IsoDateTime, PageQuery, Uuid } from './common.js';
/** GET /api/health (public, no tenant data). */
export const HealthResponse = z.object({
    status: z.enum(['ok', 'degraded']),
    version: z.string(),
    time: IsoDateTime,
    db: z.object({ ok: z.boolean(), latencyMs: z.number().nullable() }),
    migrations: z.object({
        applied: z.number().int(),
        /** Last applied, e.g. "core/0007_files_email_usage". */
        latest: z.string().nullable(),
        /** Migrations shipped in this build but not applied (should be empty). */
        pending: z.array(z.string()),
    }),
    workers: z.object({ enabled: z.boolean() }),
    /** Phase 3 (task C4): names of the module health checks that report "degraded" (names only). Absent or empty = all fine. */
    degradedChecks: z.array(z.string()).optional(),
});
export const EmailStatus = z.enum(['queued', 'sending', 'sent', 'failed']);
/** Row of the outgoing email log (GET /api/v1/emails, tenant admins see their own tenant's). */
export const EmailLogEntry = z.object({
    id: Uuid,
    templateKey: z.string(),
    to: z.string(),
    subject: z.string(),
    status: EmailStatus,
    attempts: z.number().int(),
    lastError: z.string().nullable(),
    createdAt: IsoDateTime,
    sentAt: IsoDateTime.nullable(),
});
export const EmailLogQuery = PageQuery.extend({
    status: EmailStatus.optional(),
    order: z.enum(['asc', 'desc']).default('desc'),
});
export const JobStatus = z.enum(['queued', 'running', 'done', 'failed']);
export const JobEntry = z.object({
    id: z.string(),
    tenantId: Uuid.nullable(),
    name: z.string(),
    status: JobStatus,
    attempts: z.number().int(),
    maxAttempts: z.number().int(),
    runAt: IsoDateTime,
    lastError: z.string().nullable(),
    createdAt: IsoDateTime,
    finishedAt: IsoDateTime.nullable(),
});
export const JobListQuery = PageQuery.extend({
    status: JobStatus.optional(),
    name: z.string().max(80).optional(),
    order: z.enum(['asc', 'desc']).default('desc'),
});
export const FilePurpose = z.enum(['branding_logo']);
export const FileMeta = z.object({
    id: Uuid,
    purpose: z.string(),
    originalName: z.string(),
    mime: z.string(),
    sizeBytes: z.number().int(),
    createdAt: IsoDateTime,
});
export const SignedUrlResponse = z.object({
    url: z.string(),
    expiresAt: IsoDateTime,
});
//# sourceMappingURL=system.js.map